'use client'

import { useEffect, useEffectEvent } from 'react'

/**
 * Hook that calls a handler when the window is resized.
 * Also calls the handler immediately on mount.
 * Uses useEffectEvent to ensure the latest handler is always called without needing dependencies.
 */
export function useWindowResizeHandler(handler: () => void) {
  const onResize = useEffectEvent(handler)

  useEffect(() => {
    const resizeHandler = () => onResize()
    resizeHandler()
    window.addEventListener('resize', resizeHandler)
    return () => window.removeEventListener('resize', resizeHandler)
  }, [])
}
